import { Input } from '@shared/components/ui/input';
import { Label } from '@shared/components/ui/label';
import { SectionBox } from '@shared/components/ui/SectionBox';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface RuleNameSectionProps {
  ruleName: string;
  setRuleName: (value: string) => void;
  isReadOnly?: boolean;
  /** Estilo alineado con el listado de reglas por cliente (tarjetas con cabecera en banda). */
  sectionStyle?: 'default' | 'clientCard';
}

// RuleNameSection.tsx
// Componente para editar el nombre de la regla de envío dentro del formulario de creación/edición.

export const RuleNameSection: React.FC<RuleNameSectionProps> = ({
  ruleName,
  setRuleName,
  isReadOnly = false,
  sectionStyle = 'default',
}) => {
  const { t } = useTranslation('rulesModule');

  const inner = (
    <>
      <Label htmlFor="rule-name" className="pb-3 block">
        {t('create.name_label')}
      </Label>
      <Input
        id="rule-name"
        value={ruleName}
        onChange={(e) => setRuleName(e.target.value)}
        placeholder={t('create.name_placeholder')}
        className="mb-3"
        disabled={isReadOnly}
        readOnly={isReadOnly}
      />
      <p className="text-sm text-complementary-text">{t('create.name_description')}</p>
    </>
  );

  if (sectionStyle === 'clientCard') {
    return (
      <section className="space-y-3" data-testid="rule-name-section-client">
        {inner}
      </section>
    );
  }

  return <SectionBox>{inner}</SectionBox>;
};

export default RuleNameSection;
